module.exports = __webpack_public_path__ + "images/assets/e85059bd600f46cb91af388c5954e9d0.svg";